// extracted by mini-css-extract-plugin
export default {"card":"SkillCard_card__x-T0-","heading":"SkillCard_heading__Zg6Yy","icons":"SkillCard_icons__sbLaa"};